import { Routes } from '@angular/router';
import { AdminFormComponent } from 'src/app/components/admin/admin-form/admin-form.component';
import { AdminComponent } from 'src/app/components/admin/admin.component';
import { DashboardComponent } from 'src/app/components/dashboard/dashboard.component';
import { GumClientFormComponent } from 'src/app/components/gum-client/gum-client-form/gum-client-form.component';
import { GumClientComponent } from 'src/app/components/gum-client/gum-client.component';
import { GumOrganizationFormComponent } from 'src/app/components/gum-organizations/gum-organization-form/gum-organization-form.component';
import { GumOrganizationsComponent } from 'src/app/components/gum-organizations/gum-organizations.component';
import { LoginComponent } from 'src/app/components/login/login.component';
import { ServicesComponent } from 'src/app/components/nexus-services/nexus-services.component';
import { TicketingComponent } from 'src/app/components/ticketing/ticketing.component';
import { UserFormComponent } from 'src/app/components/users/user-form/user-form.component';
import { UsersComponent } from 'src/app/components/users/users.component';
import { AuthGuard } from 'src/app/services/guards/auth.guard';
import { NexusAccessGuard } from 'src/app/services/guards/nexus-access.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '', pathMatch: 'full', redirectTo: '/dashboard' },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'organizations',
    component: GumOrganizationsComponent,
    canActivate: [AuthGuard, NexusAccessGuard],
  },
  {
    path: 'management/organization',
    component: GumOrganizationFormComponent,
    canActivate: [AuthGuard, NexusAccessGuard],
  },
  {
    path: 'clients',
    component: GumClientComponent,
    canActivate: [AuthGuard, NexusAccessGuard],
  },
  {
    path: 'management/clients',
    component: GumClientFormComponent,
    canActivate: [AuthGuard, NexusAccessGuard],
  },
  {
    path: 'management/clients/:id',
    component: GumClientFormComponent,
    canActivate: [AuthGuard, NexusAccessGuard],
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AuthGuard, NexusAccessGuard],
    data: { module: 'Administrateur' },
  },
  {
    path: 'management/admin',
    component: AdminFormComponent,
    canActivate: [AuthGuard, NexusAccessGuard],
    data: { module: 'Administrateur' },
  },
  {
    path: 'management/admin/:id',
    component: AdminFormComponent,
    canActivate: [AuthGuard, NexusAccessGuard],
    data: { module: 'Administrateur' },
  },
  {
    path: 'users',
    component: UsersComponent,
    canActivate: [AuthGuard, NexusAccessGuard],
    data: { module: 'Administrateur' },
  },
  {
    path: 'management/user',
    component: UserFormComponent,
    canActivate: [AuthGuard, NexusAccessGuard],
    data: { module: 'Administrateur' },
  },
  {
    path: 'services',
    component: ServicesComponent,
    canActivate: [AuthGuard, NexusAccessGuard],
    data: { module: 'Centrex' },
  },
  // {
  //   path: 'ticketing',
  //   component: TicketingComponent,
  //   canActivate: [AuthGuard, NexusAccessGuard],
  //   data: { module: 'Commande' },
  // },
];
